export const parseDynaBlockExtensionId = (extensionId: string | undefined): number | null => {
    const parsedExtensionId = Number(extensionId);

    return Number.isInteger(parsedExtensionId) && parsedExtensionId > 0 ? parsedExtensionId : null;
};
